module.exports = __webpack_public_path__ + "media/images/bg/hero/bialoleka-school-209e55bc20db45c70838730cba538dee.png";